<template>
  <!-- 司机管理 -->
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
       <div class="searchBtnBox">
          <el-form-item btnCode="00BP005B001"  v-if="btnFlg[0]">
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
          <el-form-item btnCode="00BP005B002"  v-if="btnFlg[1]">
            <el-button type="danger" @click="delDeiver">删除</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
       <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick" height="100%" style="width: 100%" center>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="mini" btnCode="00BP005B003"  v-if="btnFlg[2]" @click="modifyRegion(scope.row)">修改</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="name" label="车辆用途"></el-table-column>
        <el-table-column prop="remark" label="说明"></el-table-column>
        <!-- <el-table-column prop="createUserName" label="创建人"></el-table-column> -->
        <el-table-column prop="createTime" width="160" :formatter="dateFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="title"  :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
               <el-form-item label="车辆用途:" prop="name">
                <el-input  placeholder="" maxlength="12" v-model.trim="addFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="备注:" prop="remark">
                <el-input  placeholder="" maxlength="40" v-model.trim="addFrom.remark"></el-input>
              </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { cVPlist, cVPadd, cVPupdate, cVPdelete } from '@/api/vgs-driver'
export default {
  data () {
    return {
      h: '500px',
      title: '新建',
      dialogVisible: false,
      checkList: [],
      tableList: [],
      loading: 'false',
      ids: [],
      rules: {
        name: [
          { required: true, message: '请输入用途', trigger: 'blur' }
        ]
      },
      addFrom: {},
      btnFlg: [],
      btnIdArr: ['00BP005B001', '00BP005B002', '00BP005B003']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/vehicleUse')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList()
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取货物列表
    getList (searchFrom) {
      this.loading = true
      cVPlist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getGoodsList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getGoodsList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.title = '新建'
      this.addFrom = {}
      this.dialogVisible = true
      this.isAdd = true
    },
    // 修改
    modifyRegion (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            cVPadd(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            cVPupdate(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    delDeiver () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.id = []
        selectData.some(item => {
          this.ids.push(item.id)
        })
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cVPdelete({ ids: this.ids }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    closeDialog () {
      if (this.$refs.addFrom !== undefined) {
        this.$refs.addFrom.resetFields()
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>
<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
</style>
